import { GenerateQueriesArgs, generateQueries } from 'src/queries/queryGenerator'
import { SellerSubscription } from 'src/types'

export const SELLER_SUBSCRIPTIONS_ENDPOINT = 'seller_subscriptions'
export const SELLER_SUBSCRIPTIONS_QUERY_KEY = 'sellerSubscriptions'

export interface SellerSubscriptionsQueryParams {
  companyId?: Id
  marketplaceId?: Id[]
}

const generateQueriesConfig: GenerateQueriesArgs<
  SellerSubscription,
  SellerSubscriptionsQueryParams
> = {
  endpoint: SELLER_SUBSCRIPTIONS_ENDPOINT,
  queryKey: SELLER_SUBSCRIPTIONS_QUERY_KEY,
}

export const { useAllEntitiesQuery: useSellerSubscriptionsQuery } =
  generateQueries(generateQueriesConfig)
